import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import { useAudiences } from 'app/audiences/application'
import { Audience } from 'app/audiences/types'
import { PageHeadline, UserChip } from 'app/common/presentation'
import { useUser, useWorkspace } from 'app/user/application'
import { WorkspaceUser } from 'app/user/types'

import { Breadcrumb, Status } from 'components'

import { translateStatus } from '../Audiences'
import { Details, Events, Overview, Related, Treatments } from '../components'
import styles from './AudienceDetails.module.scss'

type AudienceParams = {
  id: string
}

const AudienceDetails = () => {
  const { id } = useParams<AudienceParams>() as AudienceParams
  const { t } = useTranslation('audiences')

  const { getAudience } = useAudiences()
  const { getWorkspaceUsers } = useWorkspace()
  const { user } = useUser()

  const [audience, setAudience] = useState<Audience | null>(null)
  const [createdBy, setCreatedBy] = useState<WorkspaceUser | null>()

  useEffect(() => {
    void getAudience(id).then(setAudience)
  }, [getAudience, id])

  useEffect(() => {
    void getAudience(id).then(setAudience)
  }, [getAudience, id])

  useEffect(() => {
    if (user?.isAdmin && audience?.createdBy) {
      void getWorkspaceUsers().then((result) => {
        if (result.ok) {
          setCreatedBy(result.val.find((user) => user.userId === audience.createdBy) ?? null)
        }
      })
    }
  }, [audience?.createdBy, getWorkspaceUsers, user?.isAdmin])

  return audience ? (
    <div className={styles.audienceDetails}>
      <Breadcrumb
        paths={[
          {
            name: t('overview.headline'),
            path: '/audiences',
          },
          {
            name: audience.name,
          },
        ]}
      />
      <div className={styles.headline}>
        <PageHeadline headline={<div>{t('overview.headline')}</div>} suffix={audience.id} />
        <div className={styles.rightInfo}>
          <Status status={translateStatus(audience.status)}>
            {t(`status.${audience.status}`)}
          </Status>
          {createdBy && <UserChip user={createdBy} />}
        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.column}>
          <Overview audienceId={audience.id} className={styles.overview} />
          <Events audienceId={audience.id} className={styles.events} />
          <Treatments audience={audience} className={styles.treatments} />
        </div>
        <div className={styles.column}>
          <Details audience={audience} className={styles.details} createdBy={createdBy ?? null} />
          <Related audiences={audience.related} className={styles.related} />
        </div>
      </div>
    </div>
  ) : (
    <div>Audience not found</div>
  )
}

export default AudienceDetails
